
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beneficiary/crematorium/[companyname]",
      function () {
        return require("private-next-pages/beneficiary/crematorium/[companyname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beneficiary/crematorium/[companyname]"])
      });
    }
  